<template>
  <div>
    <v-form ref="formnumber">
      <div class="col-md-12 p-0">
        <input
          type="hidden"
          name="numbers"
          id="location"
          required
          value="root"
        />
        <v-autocomplete
          outlined
          dense
          label="شماره تماس"
          :items="numbers"
          :loading="loading"
          v-model="selected_numbers"
          :filter="filter"
          v-status="'advertiseNumber_list'"
          :clearable="editNum == null"
          :readonly="!!editNum"
          small-chips
          :rules="[
            (v) =>
              !!v ||
              (Array.isArray(v) && v.length > 0) ||
              'لطفا یک شماره انتخاب کنید.',
          ]"
          chips
          :error-messages="numberError"
          clear-icon="mdi-close-circle-outline"
          item-text="phone"
          item-title="nickname"
          item-color="primary"
          item-value="id"
          :required="force"
          :multiple="this.multipleNumbers === true"
        >
          <template v-slot:prepend-inner>
            <span class="svg-icon svg-icon-primary svg-icon-2x"
              ><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/.
                ./src/media/svg/icons/Communication/Call#1.svg--><svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M11.914857,14.1427403 L14.1188827,11.9387145 C14.7276032,11.329994 14.8785122,10.4000511 14.4935235,9.63007378 L14.3686433,9.38031323 C13.9836546,8.61033591 14.1345636,7.680393 14.7432841,7.07167248 L17.4760882,4.33886839 C17.6713503,4.14360624 17.9879328,4.14360624 18.183195,4.33886839 C18.2211956,4.37686904 18.2528214,4.42074752 18.2768552,4.46881498 L19.3808309,6.67676638 C20.2253855,8.3658756 19.8943345,10.4059034 18.5589765,11.7412615 L12.560151,17.740087 C11.1066115,19.1936265 8.95659008,19.7011777 7.00646221,19.0511351 L4.5919826,18.2463085 C4.33001094,18.1589846 4.18843095,17.8758246 4.27575484,17.613853 C4.30030124,17.5402138 4.34165566,17.4733009 4.39654309,17.4184135 L7.04781491,14.7671417 C7.65653544,14.1584211 8.58647835,14.0075122 9.35645567,14.3925008 L9.60621621,14.5173811 C10.3761935,14.9023698 11.3061364,14.7514608 11.914857,14.1427403 Z"
                    fill="#000000"
                  />
                </g></svg
              ><!--end::Svg Icon--></span
            >
          </template>
          <v-checkbox
            slot="prepend-item"
            @change="handleSelectAllItems"
            hide-details
            v-if="multipleNumbers"
            class="mr-4"
            label="انتخاب همه "
          />
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.phone"
              :input-value="data.selected"
              small
              :close="multipleNumbers === true"
              @click:close="remove(data.id)"
            >
              {{ data.item.nickname }} : {{ data.item.phone }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <v-checkbox
              v-if="multipleNumbers"
              @click.stop
              v-model="selected_numbers"
              :value="data.item.id"
            ></v-checkbox>
            <v-list-item-content>
              <v-list-item-title>
                <span class="text-capitalize">
                  {{ numbers.indexOf(data.item) + 1 }} -
                  {{ data.item.nickname }}</span
                >
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="text-capitalize">{{ data.item.phone }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </div>
    </v-form>
  </div>
</template>

<script>
import { Bus } from "@/main";

export default {
  name: "numberSelector",
  props: {
    force: {
      type: Boolean,
      default: false,
    },
    has_national: {
      type: Boolean,
      default: false,
    },
    multipleNumbers: {
      type: Boolean,
      default: false,
    },
    editNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      numbers: [],
      selected_numbers: [],
      counter: 0,
      loading: false,
      numberError: "",
    };
  },
  watch: {
    selected_numbers: {
      handler(val) {
        if (val.length > 0 || val != "") {
          this.numberError = "";
          Bus.$emit("selected_numbers", val);
        }
      },
      deep: true,
    },
    has_national() {
      this.getNumbers();
    },
  },
  methods: {
    filter(item, queryText, itemText) {
      return (
        item?.nickname?.indexOf(queryText) > -1 ||
        String(item?.phone)?.indexOf(queryText) > -1
      );
    },
    getNumbers() {
      this.loading = true;
      $.ajax({
        url: `${url}/number/all?type=all`,
        type: "GET",
        fn: this.getNumbers,
        data: {
          own: this.has_national ? this.has_national : undefined,
        },
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.loading = false;
          this.numbers = data.data;
          if (this.editNum !== 0) {
            this.selected_numbers = this.numbers.filter(
              (x) => x.id === this.editNum
            );
            this.selected_numbers = this.selected_numbers[0].id;
          } else this.selected_numbers = [];
        },
        error: function () {
          this.loading = false;
        },
      });
    },
    remove(item) {
      this.selected_numbers.splice(this.selected_numbers.indexOf(item), 1);
    },
    validate() {
      let validate = true;
      if (
        !this.selected_numbers ||
        (Array.isArray(this.selected_numbers) &&
          this.selected_numbers.length === 0)
      ) {
        this.numberError = "لطفا حداقل یک شماره انتخاب کنید.";
        validate = false;
      }
      if (!this.$refs.formnumber.validate())
        this.$toast.error(this.numberError, { timeout: 5000 });
      return validate;
    },
    handleSelectAllItems(v) {
      if (v) {
        this.numbers.forEach((item) => {
          this.selected_numbers.push(item.id);
        });
      } else this.selected_numbers = [];
    },
  },
  mounted() {
    this.getNumbers();
  },
};
</script>

<style scoped></style>
